import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

// eslint-disable-next-line react/prop-types
const IconNewConfirmedOrder = ({
  className,
  height,
  width,
  fill
}: IconInterface) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox='0 0 100 101'
      fill={fill || 'none'}
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='0.5'
        y='1'
        width='99'
        height='99'
        rx='15.5'
        fill='white'
        stroke='#D6D6D6'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M50 84C68.7777 84 84 68.7777 84 50C84 31.2223 68.7777 16 50 16C31.2223 16 16 31.2223 16 50C16 68.7777 31.2223 84 50 84Z'
        fill='url(#paint0_linear_1340:7286)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M45.6568 62.065C45.1978 62.5011 44.48 62.5088 44.0118 62.0825L34.1183 53.0757C32.9171 51.9821 32.8428 50.1173 33.9532 48.9316C35.0134 47.7996 36.7747 47.6971 37.959 48.6985L44.8424 54.5185L61.7002 38.4422C62.8942 37.3036 64.7788 37.3263 65.9448 38.4935C67.1514 39.7012 67.1259 41.6659 65.8883 42.8418L45.6568 62.065Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M43.0581 63.1301L33.1646 54.1233C31.3791 52.4977 31.2687 49.7257 32.9192 47.9633C34.4951 46.2806 37.1133 46.1282 38.8737 47.6167L44.7855 52.6152L60.7225 37.417C62.4734 35.7472 65.237 35.7807 66.947 37.4922C68.7165 39.2633 68.679 42.1444 66.8641 43.8688L46.6326 63.092C45.6353 64.0396 44.0754 64.0563 43.0581 63.1301ZM44.0118 62.0825C44.48 62.5088 45.1978 62.5011 45.6568 62.065L65.8883 42.8418C67.1259 41.6659 67.1514 39.7012 65.9448 38.4935C64.7788 37.3263 62.8942 37.3036 61.7002 38.4422L44.8424 54.5185L37.959 48.6985C36.7747 47.6971 35.0134 47.7996 33.9532 48.9316C32.8428 50.1173 32.9171 51.9821 34.1183 53.0757L44.0118 62.0825Z'
        fill='white'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1340:7286'
          x1='29.8267'
          y1='29.1467'
          x2='106.1'
          y2='50.3313'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0A3040' />
          <stop offset='0.306028' stopColor='#062B58' />
          <stop offset='1' stopColor='#7F50E3' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Icon(IconNewConfirmedOrder)
